<template>
  <div class="p-envelope-status__loader h-full" v-if="loading">
    <VLoadingSpinner size="large" />
  </div>
  <div class="p-envelope-update g-page h-full" v-else>
    <VDocumentSetup
      v-if="isDraft"
      :send="sendEnvelope"
      :doc="envelope"
      :fields="fields" />
    <VMessage type="error" :fullwidth="true" v-if="!isDraft">
      <template v-slot:icon>
        <LifeRingIcon />
      </template>
      <template v-slot:text>
        {{ $t('envelope.update.messageNotDraft') }}
      </template>
    </VMessage>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VDocumentSetup from '@/views/components/DocumentSetup.vue';
import { LifeRingIcon } from '@/components/icons/fontIcons';

export default {
  name: 'EnvelopeUpdate',
  components: {
    VLoadingSpinner,
    VMessage,
    VDocumentSetup,
    LifeRingIcon,
  },
  data() {
    return {
      loading: true,
      isDraft: false,
    };
  },
  mounted() {
    const fingerprint = this.$route.params.envelopeFingerprint;
    const isUpdate = true;
    // TODO - move this out of the Promise result
    this.$store.dispatch('envelopes/GET_ENVELOPE', { fingerprint, isUpdate }).then((envelope) => {
      if (envelope.status === 'draft') {
        this.isDraft = true;
      }
    }).finally(() => {
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters({
      envelope: 'envelopes/updating',
      fields: 'envelopes/updatingFields',
    }),
  },
  methods: {
    sendEnvelope(title) {
      this.loading = true;
      this.$store.dispatch('envelopes/SEND', { title, isUpdate: true }).then((envelope) => {
        this.$router.push({
          name: 'EnvelopeStatus',
          params: { envelopeFingerprint: envelope.fingerprint },
        });
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.p-envelope-update {
  padding: 0 !important;
  border: 1px solid #dde2e5;
  border-radius:3px;
}
</style>
